import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import Pasos from "./Pasos";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/compras",
    label: "Compras",
  },
  {
    path: "/comprar",
    label: "Comprar",
    isActive: true,
  },
];

function Comprar() {
  return (
    <Page
      title="Compra de productos"
      description="Proceso de compra de productos para mascotas."
      breadCrumbs={breadCrumbs}
    >
      <Pasos />
    </Page>
  );
}

export default Comprar;
